import React from "react";

export default function Copyright() {
    return <div className={"copyright"}>
        &copy;2020 Bink Dog Inc
    </div>
}
